
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/ipl/[slug]/summary",
      function () {
        return require("private-next-pages/sports/ipl/[slug]/summary/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/ipl/[slug]/summary"])
      });
    }
  